<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <span class="brand-logo">
          <b-img
            :src="appLogoImage"
            width="180px"
            style="max-width: 180px !important"
            alt="logo"
          />
        </span>
        <!-- <h2 class="brand-text text-primary ml-1">
          CISO GRC
        </h2> -->
      </b-link>

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="MFA" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            2FA Protected. 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Open your authenticator app and enter the code
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group label="OTP" label-for="otp">
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  rules="required"
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    :state="errors.length > 0 ? false : null"
                    name="code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button type="submit" variant="primary" block>
                Verify
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>Lost your device? </span>
            <b-link :to="{ name: 'code-login' }">
              <span>&nbsp;Login with backup code</span>
            </b-link>
          </b-card-text>
          <p class="text-center mt-2">
            <b-link :to="{ name: 'login' }">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import { required, email } from "@validations";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      code: "",
      sideImg: require("@/assets/images/pages/forgot-password-v2.svg"),
      // validation
      required,
      email,
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/forgot-password-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          let mf_data = {
            temporary_token: this.$store.state.app.mfa_token,
            totp_code: this.code,
          };
          const o_options = {
            method: "POST",
            url: process.env.VUE_APP_BASEURL + "validate-totp/", //+ this.code + "/",
            data: mf_data
          };
          this.$http(o_options)
            .then((res) => {
              console.log(res);
              if (res.data) {
                let data = {
                  token: res.data.token,
                };
                // console.log(this.$store)
                this.$store
                  .dispatch("app/mfa", res, { root: true })
                  .then(() =>
                    // this.$router.push({ name: 'home'})
                    this.$router.replace(
                      localStorage.getItem("from_url") || "/"
                    )
                  )
                  .catch((err) => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Unable to log in with provided credentials.",
                        icon: "EditIcon",
                        variant: "error",
                      },
                    });
                  });
              }
            })
            .catch((err) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Unable to log in with provided credentials.",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
